import { IUseNutritionFilterModal } from './types';

export default (): IUseNutritionFilterModal => ({
  NutritionFilterModal: () => null,
  isModalOpen: true,
  openModal: () => {},
  closeModal: () => {},
});
